<template>
    <div
        class="grow aspect-square w-full h-auto relative"
        :style="{ backgroundColor: backgroundColorStyle }"
        :class="colorData.oklch.l < 0.6 ? 'text-white' : 'text-black'"
    >
        <div
            class="font-bold absolute top-2 left-4"
            :class="colorData.oklch.l < 0.6 ? 'text-white' : 'text-black'"
        >
            {{ colorData.step }}
        </div>

        <div 
            v-show="showLabels"
            class="labels-wrapper font-mono px-4 absolute top-1/2 -translate-y-[40%] left-1/2 -translate-x-1/2 w-full space-y-2"
        >
            <button
                class="block grow cursor-pointer hover:underline"
                @click="copyHex"
            >
                {{ colorData.hex.toUpperCase() }}
            </button>
            <ul class="text-xs">
                <li>L: {{ colorData.oklch.l.toFixed(4) }}</li>
                <li>C: {{ colorData.oklch.c.toFixed(4) }}</li>
                <li>H: {{ colorData.hue.toFixed(4) }}</li>
            </ul>

            {{  oklchString }}
            
            <button
                class="text-xs block grow cursor-pointer hover:underline"
                @click="copyOKLCH"
            >
                copy oklch
            </button>
        </div>
    </div>
</template>

<script>
import { store } from '../store.js'
import { computed } from 'vue'

export default {
    name: 'ColorSquare',
    props: {
        colorData: {
            type: Object,
            default: null
        }
    },
    setup(props) {
        const showLabels = computed(() => {
            return store.showLabels
        })

        const backgroundColorStyle = computed(() => {
            return props.colorData?.hex || '#ffffff'
        })

        const oklchString = computed(() => {
            if (!props.colorData?.oklch) return 'oklch(0.5 0.1 0)'
            
            const { l, c } = props.colorData.oklch
            const h = props.colorData.hue || props.colorData.oklch.h
            
            return `oklch(${l.toFixed(4)} ${c.toFixed(4)} ${h.toFixed(4)})`
        })

        return {
            showLabels,
            oklchString,
            backgroundColorStyle
        }
    },
    methods: {
        copyOKLCH() {
            navigator.clipboard.writeText(this.oklchString)
        },
        copyHex() {
            const formattedHex = this.colorData.hex.toUpperCase()
            navigator.clipboard.writeText(formattedHex)
        }
    }
}
</script>